import { action, makeObservable, observable } from 'mobx';

import { ShoppingCartItemGroupData } from '../../../app/data/model';
import { AsyncCommand } from '../../../app/shared/common';
import { NumberInput } from '../../../app/shared/Form';
import { CartItemTranslation } from '../../localization/SiteTranslation';
import { CartItemContextCommand, IContextAction } from '../CartItem/CartItemState';

export interface ICartItemGroupContextAction extends IContextAction<ShoppingCartItemGroupData> {}

export interface ICartItemGroupActions {
  contextActions: ICartItemGroupContextAction[];
  changeQuantityAction: (item: ShoppingCartItemGroupData, newQuantity: number) => Promise<void>;
}

export class CartItemGroupState {
  public updateQuantityCommand: AsyncCommand;
  public cartItemGroupContextCommands: CartItemContextCommand[] = [];

  @observable
  public quantityUpdate: NumberInput;

  constructor(
    public item: ShoppingCartItemGroupData,
    private actions: ICartItemGroupActions,
    public translation: CartItemTranslation,
  ) {
    makeObservable(this);
    this.quantityUpdate = new NumberInput(item.quantity);

    this.updateQuantityCommand = new AsyncCommand(async () => {
      await this.actions.changeQuantityAction(this.item, this.quantityUpdate.value);
    });

    this.cartItemGroupContextCommands = actions.contextActions
      .filter((x) => x.condition === undefined || x.condition(item))
      .map<CartItemContextCommand>((x) => ({
        label: x.label,
        command: new AsyncCommand(async () => await x.action(this.item)),
      }));
  }

  @action.bound
  public setQuantityUpdate(quantity: NumberInput) {
    this.quantityUpdate = quantity;
  }
}
